import React from 'react';
import PageLayout from '../../components/PageLayout';
import OperatorAssistantWorkspace from '../../components/operator-assistant/OperatorAssistantWorkspace';

export default function OperatorAssistant() {
  return <PageLayout className="operator-assistant-page"><OperatorAssistantWorkspace /></PageLayout>;
}
